"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("axios"),
    r = (e = t, e && "object" == typeof e && "default" in e ? e.default : e),
    s = r.create();

s.interceptors.response.use(function (e) {
  if (e.status < 400 && e.status >= 200) return e.data;
  throw e;
}), Object.defineProperty(exports, "HttpRequestConfig", {
  enumerable: !0,
  get: function get() {
    return t.AxiosRequestConfig;
  }
}), Object.defineProperty(exports, "HttpResponse", {
  enumerable: !0,
  get: function get() {
    return t.AxiosResponse;
  }
}), exports.default = s;